import { useTranslation } from 'react-i18next'

const ClassRoom = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="classroom-title"
      xmlSpace="preserve"
      {...props}
    >
      <title id="classroom-title">{t('antagonists:teacher:components:background')}</title>
      <defs>
        <clipPath id="classroom-b">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="classroom-c">
          <path
            style={{
              fill: '#ed774c',
            }}
            d="m1509.34 85.66.21 16.14 92.62-.66.29-15.32-93.12-.16z"
          />
        </clipPath>
        <clipPath id="classroom-d">
          <path
            style={{
              fill: '#998abc',
            }}
            d="m1504.17 99.64-.39 25.12 111.92.18-.68-25.23-110.85-.07z"
          />
        </clipPath>
        <clipPath id="classroom-e">
          <path
            style={{
              fill: '#e6a561',
            }}
            d="m1248.76 133.49 3.34 777.57 463.87 3.34-2.23-776.89-464.98-4.02z"
          />
        </clipPath>
        <clipPath id="classroom-f">
          <path
            style={{
              fill: '#f3faf9',
            }}
            d="m1569.28 186.39 3.47 145.39h91.11l-4.77-147.63-89.81 2.24z"
          />
        </clipPath>
        <clipPath id="classroom-g">
          <path
            d="M1338.67 214.78c-15.48 4.44-24.78 23.1-19.75 37.96 5.41 15.98 22.27 22.74 38.01 18.3 13.24-3.74 25.02-16.74 21.94-32.63-3.47-17.91-17.52-30.15-40.2-23.63"
            style={{
              fill: '#f5d0c4',
            }}
          />
        </clipPath>
        <clipPath id="classroom-h">
          <path
            style={{
              fill: '#c3e3e8',
            }}
            d="m1298.6 453.56 9.51 115.01 86.2-7.41-10.81-113.2-84.9 5.6z"
          />
        </clipPath>
        <style>
          {
            '.j{fill:none}.k{fill:#f3eacb}.l{fill:#f4d5b5}.m{fill:#f3faf9}.n{fill:#f6dec5}.o{fill:#f2f3f4}.p{fill:#009250}.q{fill:#008f33}.r{fill:#009634}.s{fill:#ed774c}.t{fill:#f19eb0}.u{fill:#f5d0c4}.v{fill:#eaba00}.w{fill:#f6d5dc}.x{fill:#f6a500}.y{fill:#e8d797}.aa{fill:#ffdb00}.ab{fill:#ea6727}.ac{fill:#ea6343}.ad{fill:#f1f1f3}.ae{fill:#e6a561}.af{fill:#e85127}.ag{fill:#e8523b}.ah{fill:#f0cb00}.ai{fill:#998abc}.aj{fill:#00a39a}.ak{fill:#cebac3}.al{fill:#cbded5}.am{fill:#c3e3e8}.an{fill:#dbd2d5}.ao{fill:#e1e5ea}.ap{fill:#a93985}.aq{fill:#428a3d}.ar{fill:#555849}.as{fill:#62ac6d}.at{fill:#4a4025}.au{fill:#284f4f}.av{fill:#3b9bd2}.aw{fill:#4a9055}.ax{clip-path:url(#classroom-c)}.ay{clip-path:url(#classroom-b)}.ba{clip-path:url(#classroom-e)}.bb{clip-path:url(#classroom-d)}.bc{clip-path:url(#classroom-h)}.bd{clip-path:url(#classroom-g)}'
          }
        </style>
      </defs>
      <g
        style={{
          clipPath: 'url(#classroom-b)',
        }}
        id="classroom-a"
      >
        <path
          style={{
            fill: '#cbded5',
          }}
          d="M-174.89-110.49H2056.4v1317.94H-174.89z"
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#f2f3f4',
          }}
          d="m-204.08 843.8 2343.36 6.44.03 468.89-2329.46 18.17-13.93-493.5z"
        />
        <path
          d="M1057.06 47.1c-50.41-.78-78.71 33.47-79.97 74.25-1.33 43.07 33.99 78.03 79.6 78.03 45.61 0 78.8-37.53 77.61-78.35-1.11-37.88-29.42-73.19-77.24-73.93Z"
          style={{
            fill: '#ffdb00',
          }}
        />
        <path
          d="M1056.88 56.91c-43.91-.68-68.57 29.16-69.67 64.68-1.16 37.52 29.61 67.97 69.34 67.97 39.73 0 68.65-32.69 67.61-68.25-.96-33-25.63-63.76-67.29-64.4Z"
          style={{
            fill: '#eaba00',
          }}
        />
        <path
          d="M1054.67 137.65c-.89.1-1.63-.55-1.65-1.44 0 0-1.84-66.83-1.74-67.91.14-1.6.22-2.75 1.84-3.08 1.64-.33 2.54.62 2.68 2.18.14 1.56 6.24 68.22 6.24 68.22.07.89-.59 1.7-1.48 1.8l-5.88.23Z"
          style={{
            fill: '#4a4025',
          }}
        />
        <path
          d="M1014.15 113.78c-.16.88.42 1.78 1.29 2l50.45 13.14c.86.22 1.67-.32 1.78-1.2l1.89-6.31c.12-.89-.51-1.71-1.4-1.84l-40.43-5.26c-.88-.13-7.72-1.11-10.57-1.46-2.85-.35-3.02.93-3.02.93Z"
          style={{
            fill: '#4a4025',
          }}
        />
        <path
          style={{
            fill: '#cebac3',
          }}
          d="m138.1 201.64 5.03 450.66 600.91-.81-1.2-453.94-604.74 4.09z"
        />
        <path
          style={{
            fill: '#f1f1f3',
          }}
          d="m149.61 213.37 4.83 425.48 579.07-1.12-4.86-424.36H149.61z"
        />
        <path
          d="M287.89 406.57c4.51-.62 12.21 1.77 12.4 9.18.19 7.42-5.37 10.74-9.17 10.86-5.35.18-10.53-2.63-11.5-8.76-.84-5.32 2.77-10.52 8.27-11.29"
          style={{
            fill: '#008f33',
          }}
        />
        <path
          d="M214.88 461.01c4.51-.62 12.21 1.77 12.4 9.18.19 7.42-5.37 10.74-9.17 10.86-5.35.18-10.53-2.63-11.5-8.76-.84-5.32 2.77-10.52 8.27-11.29"
          style={{
            fill: '#3b9bd2',
          }}
        />
        <path
          style={{
            fill: '#dbd2d5',
          }}
          d="m175.54 505.89 73.04-8.11 8.12 91.72-72.03 13.19-9.13-96.8z"
        />
        <path
          style={{
            fill: '#e1e5ea',
          }}
          d="m189.9 311.83 73.36 4.35 1.24 95.73-73.23.82-1.37-100.9z"
        />
        <path
          d="M208.15 493.93c4.51-.62 12.21 1.77 12.4 9.18.19 7.42-5.37 10.74-9.17 10.86-5.35.18-10.53-2.63-11.5-8.76-.84-5.32 2.77-10.52 8.27-11.29"
          style={{
            fill: '#fdd900',
          }}
        />
        <path
          d="M221.86 325.1c4.51-.62 12.21 1.77 12.4 9.18.19 7.42-5.37 10.74-9.17 10.86-5.35.18-10.53-2.63-11.5-8.76-.84-5.32 2.77-10.52 8.27-11.29"
          style={{
            fill: '#ea6727',
          }}
        />
        <path
          style={{
            fill: '#4a9055',
          }}
          d="M1062.81 302.94v3.42l.14 147.84v3.39l3.39.02 134.05.55 3.4.01.02-3.4 1.11-151.66-138.69-.16-3.42-.01z"
        />
        <path
          style={{
            fill: '#f1f1f3',
          }}
          d="m1069.78 450.92 127.79.67.51-142.02-128.44-.7.14 142.05z"
        />
        <path
          style={{
            fill: '#dbd2d5',
          }}
          d="m1084.23 321.36 37.65-.96-1.6 6.09-37.66.95 1.61-6.08zM1083.57 336.02l37.66-.95-.48 7.15-37.65.95.47-7.15zM1084.05 352.23l37.66-.96-.48 7.15-37.66.96.48-7.15zM1087.69 414.33l37.66-.96-.55 7.36-37.66.96.55-7.36zM1087.69 398.85l37.66-.95-.55 7.36-37.66.96.55-7.37zM1149.35 367l37.66-.95-.48 7.15-37.66.95.48-7.15zM1148.4 384.64l37.65-.95-1.61 7.74-37.65.95 1.61-7.74z"
        />
        <path
          style={{
            fill: '#ed774c',
          }}
          d="m1509.34 85.66.21 16.14 92.62-.66.29-15.32-93.12-.16z"
        />
        <g
          style={{
            clipPath: 'url(#classroom-c)',
          }}
        >
          <path
            style={{
              fill: '#f6a500',
            }}
            d="m1519.31 82.36.22 23.96 12.85.22-.21-25.49-12.86 1.31z"
          />
        </g>
        <path
          style={{
            fill: '#f19eb0',
          }}
          d="m1347.35 104.93.86-46.1 105.19-.46-.3 46.02-105.75.54z"
        />
        <path
          style={{
            fill: '#f19eb0',
          }}
          d="m1342.25 49.88-.27 19.39 118.22-.26-.54-19.27-117.41.14z"
        />
        <path
          style={{
            fill: '#e8523b',
          }}
          d="m1387.9 77.95.5 9.33 27.92-.13-.49-9.33-27.93.13z"
        />
        <path
          style={{
            fill: '#998abc',
          }}
          d="m1504.17 99.64-.39 25.12 111.92.18-.68-25.23-110.85-.07z"
        />
        <g
          style={{
            clipPath: 'url(#classroom-d)',
          }}
        >
          <path
            style={{
              fill: '#a93985',
            }}
            d="m1533.89 95.55.66 34.74 37.82.68.68-35.77-39.16.35z"
          />
        </g>
        <path
          style={{
            fill: '#009250',
          }}
          d="m1339.97 102.67-.68 20.36 148.3.92-.37-20.79-147.25-.49z"
        />
        <path
          style={{
            fill: '#f4d5b5',
          }}
          d="m1239.9 121.93 2.53 822.36 484.44 3.49-1.37-821.64-485.6-4.21z"
        />
        <path
          style={{
            fill: '#e6a561',
          }}
          d="m1248.76 133.49 3.34 777.57 463.87 3.34-2.23-776.89-464.98-4.02z"
        />
        <g
          style={{
            clipPath: 'url(#classroom-e)',
          }}
        >
          <path
            style={{
              fill: '#f4d5b5',
            }}
            d="m1490.45 119.62-1.38 816.01h8.13l-.56-818.79-6.19 2.78z"
          />
        </g>
        <path
          style={{
            fill: '#f6dec5',
          }}
          d="M1508.37 540.57v29.46h22.27l-1.83-29.59-20.44.13z"
        />
        <path
          d="M1513.31 545.76s.47 8.21.47 18.52.17 17.96.17 17.96l6.62.23s4.34-11.67 4.61-19.27c.27-7.6-1.4-17.44-1.4-17.44h-10.47Z"
          style={{
            fill: '#555849',
          }}
        />
        <path
          style={{
            fill: '#f6dec5',
          }}
          d="M1477.11 539.76v29.45h-22.27l-.28-29.86 22.55.41z"
        />
        <path
          d="M1471.52 546.39s-.47 8.21-.47 18.52c0 10.31-.17 17.96-.17 17.96l-6.62.23s-4.34-11.67-4.61-19.27c-.27-7.6 1.4-17.44 1.4-17.44h10.47Z"
          style={{
            fill: '#555849',
          }}
        />
        <path
          style={{
            fill: '#f6d5dc',
          }}
          d="m1340.26 332.34 4.49 94.3 67.36-2.24v-96.55l-71.85 4.49z"
        />
        <path
          style={{
            fill: '#f3faf9',
          }}
          d="m1569.28 186.39 3.47 145.39h91.11l-4.77-147.63-89.81 2.24z"
        />
        <g
          style={{
            clipPath: 'url(#classroom-f)',
          }}
        >
          <path
            style={{
              fill: '#00a39a',
            }}
            d="m1685.51 197.48-12.95-42.52-143.7 2.24 1.56 43.57 155.09-3.29z"
          />
        </g>
        <path
          style={{
            fill: '#f3faf9',
          }}
          d="m1307.6 193.64-4.49 105.53 87.42-.05-2.09-105.48h-80.84z"
        />
        <path
          d="M1338.67 214.78c-15.48 4.44-24.78 23.1-19.75 37.96 5.41 15.98 22.27 22.74 38.01 18.3 13.24-3.74 25.02-16.74 21.94-32.63-3.47-17.91-17.52-30.15-40.2-23.63"
          style={{
            fill: '#f5d0c4',
          }}
        />
        <g
          style={{
            clipPath: 'url(#classroom-g)',
          }}
        >
          <path
            style={{
              fill: '#428a3d',
            }}
            d="M1347.24 197.55v43.17l53.05-1.56-4.16-43.69-48.89 2.08z"
          />
          <path
            d="m1359.2 283.89-11.96-43.17 47.33-10.4-3.64 38.49s-33.29 15.08-31.73 15.08Z"
            style={{
              fill: '#f0cb00',
            }}
          />
          <path
            style={{
              fill: '#e85127',
            }}
            d="m1367 296.38-19.76-55.66-26.53 42.65 46.29 13.01z"
          />
          <path
            d="m1347.76 190.79-.52 49.93s-53.05-8.84-50.97-8.84 51.49-41.09 51.49-41.09Z"
            style={{
              fill: '#62ac6d',
            }}
          />
        </g>
        <path
          d="M1374.88 353.19s-11.37-8.47-21.54 0c-12.92 10.77 35.41 53.65 35.41 53.65s20.59-45.75 11.26-57.96c-9.33-12.2-25.13 4.31-25.13 4.31Z"
          style={{
            fill: '#ea6343',
          }}
        />
        <path
          style={{
            fill: '#c3e3e8',
          }}
          d="m1298.6 453.56 9.51 115.01 86.2-7.41-10.81-113.2-84.9 5.6z"
        />
        <g
          style={{
            clipPath: 'url(#classroom-h)',
          }}
        >
          <path
            d="M1284 550.25s51.97-11.99 93.89-20.21l41.92-8.22 29.95-5.28-1.76 81.04-165.59 24.66 1.59-71.98Z"
            style={{
              fill: '#009634',
            }}
          />
        </g>
        <path
          d="M1344.32 457.81c10.75-1.48 29.06 4.22 29.51 21.86.46 17.66-12.79 25.56-21.83 25.86-12.75.42-25.07-6.27-27.37-20.85-2.01-12.66 6.59-25.05 19.7-26.87M1327.5 506.83l-13.64 25.84 3.64 2.53 14.43-26.81-4.43-1.56zM1338.56 513.22l.25 27.72 4.53.2 3.39-32.36-8.17 4.44zM1357.66 507.75l7.63-2.68 12.98 30.72-3.71 1.85-16.9-29.89zM1323.23 497.44l-11.76 4.54-1.44-3.1 12.58-6.59.62 5.15zM1320.55 481.57l-10.93-1.44-.41-3.71h11.75s-.82 5.36-.41 5.15ZM1373.33 497.44l-1.65 3.5 14.23 10.72 1.24-2.89s-14.02-11.13-13.81-11.34Z"
          style={{
            fill: '#fdd900',
          }}
        />
        <path
          style={{
            fill: '#dbd2d5',
          }}
          d="m1578.29 220.3 72.47-2.13 1.43 4.98-73.34 3.12-.56-5.97zM1578.55 235.11l72.64-2.78.19 5.63-72.83 1.8v-4.65zM1579.34 250.3l67.96-1.22v5l-67.63 1.1-.33-4.88zM1607.31 287.82l39.1-1.22v5l-38.92 1.1-.18-4.88zM1606.95 297.38l39.1-1.22v5l-38.91 1.1-.19-4.88zM1606.17 308.03l39.1-1.22v5l-38.92 1.1-.18-4.88z"
        />
        <path
          style={{
            fill: '#f3eacb',
          }}
          d="m1368.89 318.08 2.17 20.53 7.9-1.32-2.47-20.06-7.6.85z"
        />
        <path
          style={{
            fill: '#e8d797',
          }}
          d="m1315.22 188.33-.51 14.41 7.93.57.16-14.14-7.58-.84zM1375.78 188.21l-.5 14.41 7.93.57.15-14.15-7.58-.83z"
        />
        <path
          d="m317.87-65.45 10.84 41.34a6.806 6.806 0 0 0 6.56 5.25l4.46.06.74 93.16 3.64-.02-.74-93.12 4.94.05c3.21.03 6.01-2.18 6.72-5.31l9.43-41.38-46.58-.05Z"
          style={{
            fill: '#284f4f',
          }}
        />
        <path
          d="M354.23 52.06c-42.49-5.95-66.82 13.31-73.07 40.79-6.53 28.8 2.7 64.26 42.55 73.9 40.54 9.8 77.49-16.4 79.97-46.86 2.32-29.06-6.97-61.87-49.45-67.82Z"
          style={{
            fill: '#f1f1f3',
          }}
        />
      </g>
    </svg>
  )
}

export default ClassRoom
